// extracted by mini-css-extract-plugin
export default {"svgIconWrapper":"fqOvMP","play":"MnLZSo","pause":"M9EbbJ"};